import { useCallback, useMemo, useState } from 'react';
import Raven from 'raven-js';
import { savePreferences, unsubscribeAll } from '../../api/managePreferences';
import { getDataParam, moveToPage } from '../../utils/common';
export default function useManagePreference(userPreferences) {
  const {
    subscriptionStatuses,
    email,
    company,
    showSurvey
  } = userPreferences;
  const dataParam = getDataParam();
  const getSubscriptionStatuses = () => {
    try {
      return subscriptionStatuses.reduce((acc, curr) => {
        acc[curr.id] = curr.checkboxChecked;
        return acc;
      }, {});
    } catch (err) {
      Raven.captureException(err, {
        extra: {
          location: 'hooks/useManagePreference/getSubStatus',
          url: window.location.href
        }
      });
      throw err;
    }
  };
  const [subscriptionStates, setSubscriptionState] = useState(getSubscriptionStatuses);
  const redirectStateData = useMemo(() => ({
    company,
    email,
    dataParam,
    showSurvey: showSurvey || false,
    isUnsubscribeAll: false
  }), [company, email, dataParam, showSurvey]);
  const onSubscriptionChange = useCallback(subscriptionId => {
    const newState = Object.assign({}, subscriptionStates);
    const prevSubState = newState[subscriptionId];
    newState[subscriptionId] = !prevSubState;
    setSubscriptionState(newState);
  }, [subscriptionStates]);
  const onClickManagePreference = useCallback(() => {
    const subscribedIds = [];
    const unsubscribedIds = [];
    for (const subId in subscriptionStates) {
      if (subscriptionStates[subId]) {
        subscribedIds.push(Number(subId));
      } else {
        unsubscribedIds.push(Number(subId));
      }
    }
    const onClickManagePreferencePromise = async () => {
      try {
        await savePreferences(subscribedIds, unsubscribedIds, dataParam);
        moveToPage('manage/confirmation', redirectStateData);
      } catch (err) {
        Raven.captureException(err, {
          extra: {
            location: 'hooks/useManagePreference/onClickManagePreference'
          }
        });
        moveToPage('/backup');
      }
    };
    return onClickManagePreferencePromise();
  }, [subscriptionStates, redirectStateData, dataParam]);
  const onClickUnsubscribeAll = useCallback(() => {
    const onClickUnsubscribeAllPromise = async () => {
      try {
        await unsubscribeAll(dataParam);
        moveToPage('unsubscribe/confirmation', Object.assign({}, redirectStateData, {
          isUnsubscribeAll: true
        }));
      } catch (err) {
        Raven.captureException(err, {
          extra: {
            location: 'hooks/useManagePreference/onClickUnsubscribeAll'
          }
        });
        moveToPage('/backup');
      }
    };
    return onClickUnsubscribeAllPromise();
  }, [redirectStateData, dataParam]);
  return {
    subscriptionStates,
    onSubscriptionChange,
    onClickManagePreference,
    onClickUnsubscribeAll
  };
}